import request from '@/utils/request'

//管理员端登录
export function login(username, password,companyId) {
  return request({
    // url: '/admin/login',
    url: '/oauth/token?grant_type=password&client_secret=123456&client_id=admin-app',
    method: 'post',
    data: {
      username,
      password,
      companyId
    }
  })
}
//商户端登录
export function loginMerchant(username, password) {
  return request({
    url: '/merchant/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}
//业务端登录
export function loginAgent(username, password) {
  return request({
    url: '/agent/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}
//资方端端登录
export function loginCapital(username, password) {
  return request({
    url: '/fund/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}
export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}
export function adminList(params) {
  return request({
    url: '/admin/adminList',
    method: 'get',
    params: params
  })
}

export function workerList(params) {
  return request({
    url: '/admin/workerList',
    method: 'get',
    params: params
  })
}

export function workerList_export(data) {
  return request({
    url: '/admin/workerList_export',
    method: 'get',
    responseType: 'blob',
    params: data
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js